export enum Frequency {
  Once,
  Weekly,
  Fortnightly,
  Monthly,
  Sixmonthly,
  Yearly
}

export interface RecurrentItem {
  description : string;
  nextdue : number;
  amount : number;
  frequency : Frequency;
}


export interface Recurrent {
  items : RecurrentItem[];
}


export interface BalanceItem {
  date : number,
  description : string,
  balance : number
}
